import React from "react";
import { Box } from "@mui/material";
import { ReportToolbar } from "../reports/ReportPageLayout";

/**
 * Manage-screen actions row: portals into ReportPageLayout title row when wrapped,
 * otherwise renders inline (same behavior as ReportToolbar).
 */
export function PageToolbarRow({ children, highlight = false }) {
  return (
    <ReportToolbar>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          flexWrap: "wrap",
          gap: 1,
          maxWidth: "100%",
          ...(highlight
            ? {
                color: "#4fc3f7",
                backgroundColor: "rgb(255, 234, 231)",
                borderRadius: 1,
                px: 1,
                py: 0.25,
              }
            : {}),
        }}
      >
        {children}
      </Box>
    </ReportToolbar>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/PageToolbarRow.js